export default {"src":"/_next/static/media/tablet.931749b5.svg","height":71,"width":71};